import React from 'react';
import Cookies from 'js-cookie';

import VBPhoneInput from '@vb-js-commons/new/vbPhoneInput';
import VBMultiOption from '@vb-js-commons/new/vbMultiOption';
import { TwModal } from '@ui-component-library';
import { validateForm} from '../vb-django/api';
class ComplementInfo extends React.Component {
    constructor(props){
        super();
        this.state={
            errors: {},
            munis: [],
            roles: [],
            phoneno: "",
            complementInfoModal: props.show_modal,
            formData: {}
        }
        this.rolesRef = React.createRef();
        this.munisRef = React.createRef();
        this.phoneInputRef = React.createRef();

    }

    validateFormFields(data){
    
        let checkList = [];
        if ((Window.user_data.regions).length < 1 && !data.munis ){
            checkList.push('muni')
        }
        if ((Window.user_data.roles).length < 1 && !data.roles){
            checkList.push('roles')
        }
        if (!Window.user_data.mobilePhoneNumber ){
            checkList.push('mobile_phone_number')
        }
    
        let validation = validateForm(data, checkList, true)
        
        //double '!!' to convert a value to a boolean: true/false
        let has_error = !!Object.values(validation).find(val => val)

        return {has_error, validation};
           
    }

    submit() {
        const headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': Cookies.get('csrftoken')
        }
        let data = this.state.formData
        let { has_error, validation } = this.validateFormFields(data)

        if (has_error) {
            this.setState({ errors: validation });
            return;
        } else {

            fetch("/user_complement_info_landing/", {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ "data": data }),
            }).then(resp => resp.json()).then((json) => {
                if (json.errors) {
                    let validation_phone = {}
                    if (json.errors.mobile_phone_number) {
                        validation_phone.mobile_phone_number = json.errors.mobile_phone_number
                        this.setState({ errors: validation_phone })
                    } else {
                        this.setState({ errors: json.errors })
                        return;
                    }
                } else {
                    this.setState({ complementInfoModal: false })
                }
            })
        }
    }

    render() {
        if (!this.state.complementInfoModal){
            return null;
        }
        return (
            <TwModal isOpen={this.state.complementInfoModal} className="bg-neutral-cloud-200 neutral-charcoal p-6" style={{zIndex: 1056}}>
              <TwModal.Content>
                  <h3 className="mb-2 text-[20px] leading-[1.2] tracking-[-0.4px] md:text-[25px] md:leading-[1.12] md:tracking-[-0.5px]">Komplett information</h3>
                  <p className="text-[16px] leading-[125%] tracking-[-0.32px]">Treebula strävar alltid att förbättra tjänsten. Vi ber dig därför att nu komplettera information som vi saknar.</p>
                  {/* Choose Roles for user if they dont have any */}
                  {(Window.user_data.roles).length < 1 ? (
                  <div>
                      <VBMultiOption 
                      ref = {this.rolesRef}
                      options={Window.react_data.lists.roles}    
                      label={<label>Ange din roll(er)</label>}
                      optionsContainerStyle={{zIndex:1056}}
                      onChange={(val) => {
                          this.setState({formData:{...this.state.formData, roles: val.map((itm) => itm.value) }});
                      }}
                      error={this.state.errors?.roles}
                      onFocus={() => this.setState({ errors: { ...this.state.errors, roles: '' } })}
                      />
                  </div>
                  ) : null}
                  {/* Choose Muni for user if they dont have any */}
                  {(Window.user_data.regions).length < 1 ? (
                  <div>
                      <VBMultiOption
                      ref = {this.munisRef}
                      options={Window.react_data.lists.munis}
                      label={<label className="mt-6">Välj kommun(er)</label>}
                      optionsContainerStyle={{zIndex:1056}}
                      onChange={(val) => {
                          this.setState({ formData:{...this.state.formData, munis: val.map((itm) => itm.value) }});
                      }}
                      error={this.state.errors?.muni}
                      onFocus={() => this.setState({ errors: { ...this.state.errors, muni: '' } })}
                      />
                  </div>
                  ) : null}
                  {/* Enter Telephone Number for user if they dont have any */}
                  {!Window.user_data.mobilePhoneNumber ? (
                  <div>
                      <VBPhoneInput
                      ref = {this.phoneInputRef}
                      label={
                          <label className="mt-6">Ange ditt telefonnummer: </label>
                      }
                      onChange={(val) => {
                          this.setState({formData: {...this.state.formData, mobile_phone_number: val} });
                      }}
                      error={this.state.errors?.mobile_phone_number}
                      onFocus={() => this.setState({ errors: { ...this.state.errors, mobile_phone_number: '' } })}
                      />
                  </div>
                  ) : null}

                  <div className='flex flex-wrap justify-end'>
                      <button class="transition-all duration-300 ease-out text-[1em] text-center py-[11px] px-8 rounded-[30px] border text-white bg-[#023436] border-[#023436] max-[992px]:py-[11px] max-[992px]:px-6 max-[992px]:text-[.8em] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#144143] enabled:hover:border-[#144143] enabled:active:bg-[#012526] enabled:active:border-[#012526] mt-4 md:w-1/4 w-1/2" onClick={() => {this.submit();}}>Fortsätt</button>
                  </div>
              </TwModal.Content>
            </TwModal>
          );
    }
}
export default ComplementInfo;